// extracted by mini-css-extract-plugin
module.exports = {"editForm":"MyAccountFiglioFormCard_editForm__XXzmp","rotation":"MyAccountFiglioFormCard_rotation__ksNsP"};